import { useMutation } from '@tanstack/react-query';

import { api } from '@/api/client';
import type { PrescriptionResult } from '@/api/types';

/**
 * Transcribes a prescription photo and suggests inventory matches for each
 * medicine line. Nothing is added to the cart server-side — the pharmacist
 * confirms every line client-side.
 */
export function usePrescriptionOcr() {
  return useMutation({
    mutationFn: (request: { imageBase64: string; mimeType: string }) =>
      api.post<PrescriptionResult>('/api/ocr/prescription', request),
  });
}
